import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "var(--color-black)",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10 2.5a7.5 7.5 0 1 0 0 15 .833.833 0 0 1 0 1.667A9.167 9.167 0 1 1 10 .833.833.833 0 0 1 10 2.5" }, null, -1),
    _createElementVNode("path", { d: "M10 2.5a7.5 7.5 0 1 1 0 15 .833.833 0 0 0 0 1.667A9.167 9.167 0 0 0 10 .833.833.833 0 1 0 10 2.5" }, null, -1),
    _createElementVNode("path", { d: "M13.506 7.744a.833.833 0 0 1 0 1.179l-3.75 3.75a.833.833 0 0 1-1.179 0l-1.666-1.667a.833.833 0 1 1 1.178-1.179l1.077 1.078 3.161-3.16a.833.833 0 0 1 1.179 0" }, null, -1)
  ]))]))
}
export default { render: render }